import React, { useEffect } from "react";
import { Snackbar, Alert, Slide } from "@mui/material";
import { useAuthContext } from "../context/AuthContext";

export default function Notification() {
  const { notification, setNotification } = useAuthContext();

  function TransitionLeft(props) {
    return <Slide {...props} direction="right" />;
  }

  return (
    <>
      <Snackbar
        severity="success"
        color="white"
        autoHideDuration={2500}
        onClose={(event, reason) => {
          setNotification({ open: false });
        }}
        TransitionComponent={TransitionLeft}
        open={notification.open}
        my={5}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert
          variant="filled"
          severity={notification.color}
          sx={{ width: "100%", marginBottom: "20%" }}
        >
          {notification?.message}
        </Alert>
      </Snackbar>
    </>
  );
}
